import { Badge, badgeVariants, iconTypes, Text } from '@cascade/ui-library';
import clsx from 'clsx';
import classes from './ExperienceHeading.module.scss';
import type {
  TExperienceHeadingProps,
  THeadingStyles,
} from './ExperienceHeading.types.ts';

const headingStyles: THeadingStyles = {
  h2: {
    badgeVariant: 'light',
    descriptionType: 'body',
    descriptionColor: 'text-base',
  },
  h3: {
    badgeVariant: 'light',
    descriptionType: 'body-2',
    descriptionColor: 'text-base',
  },
  h4: {
    badgeVariant: 'brand',
    descriptionType: 'caption',
    descriptionColor: 'text-60',
  },
};

export const ExperienceHeading = ({
  icon,
  iconColor,
  title,
  description,
  level,
}: TExperienceHeadingProps) => {
  const headingStyle = headingStyles[level];
  const iconType = iconTypes.find((type) => type === icon);
  const hasIcon = Boolean(iconType);
  const badgeVariant =
    badgeVariants.find((variant) => variant === iconColor) ??
    headingStyle.badgeVariant;

  if (!iconType && !title && !description) {
    return null;
  }

  return (
    <div
      className={clsx(classes['experience-heading'], classes[level], {
        [classes['with-icon']]: hasIcon,
      })}
    >
      {iconType ? (
        <Badge
          label={title ?? iconType}
          iconType={iconType}
          variant={badgeVariant}
          iconOnly
        />
      ) : null}
      {title ? (
        <Text type={level} weight='semibold' content={title} compact />
      ) : null}
      {description ? (
        <div className={classes.description}>
          <Text
            type={headingStyle.descriptionType}
            color={headingStyle.descriptionColor}
            content={description}
          />
        </div>
      ) : null}
    </div>
  );
};
